import { baseErrorHandler } from '@queries/baseErrorHandler';
import { $api } from '@service/RequestService';
import { useMutation, useQueryClient } from 'react-query';

import { crmConstants } from '..';

export function useGoogleSheetsDelete() {
  const qc = useQueryClient();

  const { data, ...arg } = useMutation(
    async (payload: number) => {
      const { data } = await $api.delete(`/v1/crm/drive/config/${payload}`);

      return data;
    },
    {
      onError: baseErrorHandler,
      onSuccess: async () => {
        await qc.invalidateQueries([crmConstants.queryKeys.GOOGLE_SHEETS_ACCOUNT]);
      }
    }
  );

  return { data, ...arg };
}
